/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
import o from"./GPOptions.js";import{constructRequest as r}from"./utils.js";import t from"../support/JobInfo.js";async function s(s,m,n,f){return n=o.from(n||{}),r(s,"submitJob",n,m??{},f).then((({data:o})=>{const r=t.fromJSON(o);return r.sourceUrl=s,r}))}export{s as submitJob};
